import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Checkbox,
  Link
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid } from '@mui/x-data-grid';
import Rate from 'rsuite/Rate'; // assuming you're using rsuite for rating
import { dateDifference, formatDate, formatDateText } from './CommonFunctions';

export default function RepairModal({
  open,
  onClose,
  roomNumber,
  data = []
}) {
  const columns = [
    {
      field: 'id',
      headerName: 'Ticket No.',
      width: 80,
      align: 'left',
      renderCell: (params) => {
        const currentRow = params.row;
        return (
          <Link 
        //   onClick={() => handleShowAddRepair(currentRow.id)}
          >
            {currentRow.id}
          </Link>
        );
      },
    },
    {
      field: 'roomid',
      headerName: 'Room No.',
      width: 80,
      align: 'left',
      renderCell: (params) => <>{params.row.roomid}</>,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 250,
      align: 'left',
      renderCell: (params) => (
        <div
          style={{
            lineHeight: '1.5em',
            whiteSpace: 'normal',
            wordBreak: 'break-all',
            overflowWrap: 'anywhere',
            display: 'block',
          }}
        >
          {params.row.description}
        </div>
      ),
    },
    {
      field: 'priority',
      headerName: 'Priority',
      width: 80,
      align: 'left',
    },
    {
      field: 'scheduledDate',
      headerName: 'Scheduled at',
      width: 150,
      align: 'left',
      renderCell: (params) =>
        params.row.scheduledDate
          ? formatDateText(params.row.scheduledDate)
          : null,
    },
    { field: 'assignedto', headerName: 'Assigned to', width: 150 },
    { field: 'status', headerName: 'Status', width: 150 },
    {
      field: 'createdAt',
      headerName: 'Created at',
      width: 150,
      align: 'left',
      renderCell: (params) =>
        params.row.createdAt
          ? formatDateText(formatDate(params.row.createdAt))
          : null,
    },
    {
      field: 'daysOpen',
      headerName: 'Days Open',
      width: 100,
      align: 'left',
      renderCell: (params) =>
        dateDifference(
          params.row.createdAt,
          params.row.completedDate ? params.row.completedDate : new Date()
        ),
    },
    {
      field: 'completedDate',
      headerName: 'Completed at',
      width: 150,
      align: 'left',
      renderCell: (params) =>
        params.row.completedDate
          ? formatDateText(params.row.completedDate)
          : null,
    },
    { field: 'managerComments', headerName: 'Manager Comments', width: 200 },
    {
      field: 'managerRatingOnRepair',
      headerName: 'Rating',
      width: 150,
      align: 'left',
      renderCell: (params) => (
        <Rate
          size="xs"
          style={{ width: '100px' }}
          value={params.row.managerRatingOnRepair}
          readOnly
        />
      ),
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Open Repair Tickets for Room - {roomNumber}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <div style={{ height: 500, width: '100%' }}>
          <DataGrid
            rows={data}
            columns={columns}
            getRowId={(row) => row.id}
            disableSelectionOnClick
            pageSize={10}
             getRowHeight={() => 'auto'}
             sx={{
    '& .MuiDataGrid-cell': {
      paddingTop: '12px',
      paddingBottom: '12px',
      alignItems: 'start', // ensure multi-line content starts at top
    },
  }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
